import React from 'react';
import { useSelector } from 'react-redux';
import { SearchProps } from '../../pages/arc/models/arc-epi-props';
import { TcsmStates } from '../../root/tcsm-model';
import { SortLabel } from '../components/sort-label';
import { FilterTypes } from '../models/search-models';

export function EmployeeChangeLogLabels() {

    const searchSettings = useSelector<TcsmStates, SearchProps>(state => state?.epiProps?.searchSettingsState?.epiContent);

    return (
        <div className='sort-table-row'>
            <div className='sort-table-row-cell'>
                <SortLabel type={FilterTypes.submittedDate} labelText={searchSettings?.submittedDateLabel} />
            </div>
            <div className='sort-table-row-cell'>
                <SortLabel type={FilterTypes.employee} labelText={searchSettings?.employeeLabel} />
            </div>
            <div className='sort-table-row-cell'>
                <SortLabel type={FilterTypes.eventType} labelText={searchSettings?.eventTypeLabel} />
            </div>
            <div className='sort-table-row-cell'>
                <SortLabel type={FilterTypes.effectiveDate} labelText={searchSettings?.effectiveDateLabel} />
            </div>
            <div className='sort-table-row-cell'>
                <SortLabel type={FilterTypes.submittedBy} labelText={searchSettings?.submittedByLabel} />
            </div>
        </div>

    );
}
